import React from 'react';
import PropTypes from 'prop-types';
import { DialogWrapper, StyledDialog } from './Dialog.styled';
import DialogTitle from './DialogTitle';

const Dialog = ({ id, open, children, width, height, onClose }) => {
  const titleId = `${id}-title`;

  return (
    <StyledDialog
      scroll="paper"
      open={open}
      aria-label={titleId}
      onClose={onClose}
      aria-modal
    >
      <DialogWrapper width={width} height={height}>
        {React.Children.toArray(children).map((child) => {
          if (child.type === DialogTitle) {
            return React.cloneElement(child, {
              onClose,
              id: titleId,
            });
          }
          return child;
        })}
      </DialogWrapper>
    </StyledDialog>
  );
};

Dialog.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.node,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

Dialog.defaultProps = {
  open: false,
  onClose: undefined,
  width: '492',
  height: '630',
};

export default Dialog;
